module.exports = __webpack_public_path__ + "static/media/Espn.566f1559.png";